import React, { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';
import useSiteContent from '../../hooks/useSiteContent';
import { siteLinks } from '../../content/siteContent';

export default function HeaderBar() {
  const { language, setLanguage, siteContent } = useSiteContent();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <header className="site-header">
      <div className="site-header__container">
        <NavLink exact to="/" className="site-header__brand">
          <span className="site-header__brand-mark">BJ</span>
          <span>
            <strong>{siteContent.header.brand}</strong>
            <small>{siteContent.header.tagline}</small>
          </span>
        </NavLink>

        <button
          type="button"
          className="site-header__toggle"
          aria-label={menuOpen ? 'Close navigation' : 'Open navigation'}
          onClick={() => setMenuOpen((current) => !current)}
        >
          {menuOpen ? <FaTimes /> : <FaBars />}
        </button>

        <div className={`site-header__panel ${menuOpen ? 'is-open' : ''}`}>
          <nav className="site-nav" aria-label="Main Navigation">
            {siteContent.header.nav.map((item) => (
              <NavLink
                key={item.to}
                exact={item.to === '/'}
                to={item.to}
                className="site-nav__link"
                activeClassName="is-active"
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="site-header__actions">
            <div className="language-switch" aria-label={siteContent.header.language} role="group">
              <button
                type="button"
                className={`language-switch__button ${language === 'tr' ? 'is-active' : ''}`}
                onClick={() => setLanguage('tr')}
              >
                TR
              </button>
              <button
                type="button"
                className={`language-switch__button ${language === 'en' ? 'is-active' : ''}`}
                onClick={() => setLanguage('en')}
              >
                EN
              </button>
            </div>

            <a
              className="button button--primary button--small"
              href={siteLinks.bookingUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              {siteContent.common.bookNow}
            </a>
          </div>
        </div>
      </div>
    </header>
  );
}
